module.exports = __webpack_public_path__ + "dist/img/zhangyuqi.dfc22e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/zhangyuqi.png
// module id = 2dHx
// module chunks = 1